import React, {Component} from 'react';
import {NavBar,Toast} from "antd-mobile";
import "./style.less";
export default class ApplyInvoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    componentDidMount() {
    }



    render() {
        return (
            <div className="applyInvoice">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()}/>}
                >发票</NavBar>
            <div className="contentBox">
                <div onClick={()=>this.props.history.push('/invoice',1)}>
                    <span>预约出行开票</span>
                    <i className="icon iconfont icontiaozhuan"/>
                </div>
                <div onClick={()=>this.props.history.push('/invoice',2)}>
                    <span>城内开票</span>
                    <i className="icon iconfont icontiaozhuan"/>
                </div>
                <div onClick={()=>this.props.history.push('/invoice',4)}>
                    <span>专车预约开票</span>
                    <i className="icon iconfont icontiaozhuan"/>
                </div>
                <div onClick={()=>this.props.history.push('/invoice',5)}>
                    <span>接送站开票</span>
                    <i className="icon iconfont icontiaozhuan"/>
                </div>
                <div onClick={()=>this.props.history.push('/invoice',7)}>
                    <span>带货开票</span>
                    <i className="icon iconfont icontiaozhuan"/>
                </div>
            </div>
            <div className="contentBox">
                <div onClick={()=>this.props.history.push('/invoiceHistory')}>
                    <span>开票历史</span>
                    <i className="icon iconfont icontiaozhuan"/>
                </div>
            </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Invoice/ApplyInvoice/index.js